import Colors from 'constants/colors'
import Link from 'next/link'
import React from 'react'

import * as SC from './styles'

type ButtonProps = {
  onClick?: () => void
  iconLeft?: JSX.Element
  iconRight?: JSX.Element
  href?: string
  target?: string
  link?: string
  children: React.ReactNode
  colorText?: string
  colorBtn?: string
  variant?: 'text' | 'contained' | 'outlined'
  big?: boolean
}

const ButtonNew: React.FC<ButtonProps> = props => {
  const {
    onClick,
    iconLeft,
    iconRight,
    href,
    target,
    link,
    children,
    colorText = Colors.white,
    colorBtn = Colors.blue,
    variant = 'contained',
    big
  } = props
  const renderContent = () => {
    return (
      <>
        {iconLeft && <SC.IconLeft>{iconLeft}</SC.IconLeft>}
        {children}
        {iconRight && <SC.IconRight>{iconRight}</SC.IconRight>}
      </>
    )
  }

  return (
    <SC.Base>
      {href ? (
        <SC.Button
          href={href}
          target={target}
          as="a"
          colorText={colorText}
          colorBtn={colorBtn}
          outlined={variant === 'outlined'}
          contained={variant === 'contained'}
          big={big}
        >
          {renderContent()}
        </SC.Button>
      ) : link ? (
        <Link href={link}>
          <SC.Button
            href={link}
            as="a"
            colorText={colorText}
            colorBtn={colorBtn}
            outlined={variant === 'outlined'}
            contained={variant === 'contained'}
            big={big}
          >
            {renderContent()}
          </SC.Button>
        </Link>
      ) : (
        <SC.Button
          onClick={onClick}
          colorText={colorText}
          colorBtn={colorBtn}
          outlined={variant === 'outlined'}
          contained={variant === 'contained'}
          big={big}
        >
          {renderContent()}
        </SC.Button>
      )}
    </SC.Base>
  )
}

export default ButtonNew
